/**
 * MIRA DropdownMenu Component
 * Wraps Shadcn DropdownMenu with MIRA design system styles
 */

import React from 'react';
import {
  DropdownMenu as ShadcnDropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent as ShadcnDropdownMenuContent,
  DropdownMenuItem as ShadcnDropdownMenuItem,
  DropdownMenuCheckboxItem as ShadcnDropdownMenuCheckboxItem,
  DropdownMenuRadioItem as ShadcnDropdownMenuRadioItem,
  DropdownMenuLabel as ShadcnDropdownMenuLabel,
  DropdownMenuSeparator as ShadcnDropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuGroup,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuRadioGroup,
} from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/dropdown-menu.module.css';

export const DropdownMenu = ({ children, ...props }) => {
  return <ShadcnDropdownMenu {...props}>{children}</ShadcnDropdownMenu>;
};

export const DropdownMenuContent = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnDropdownMenuContent
        ref={ref}
        className={cn(styles.miraDropdownMenuContent, className)}
        {...props}
      />
    );
  }
);

DropdownMenuContent.displayName = 'MiraDropdownMenuContent';

export const DropdownMenuItem = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnDropdownMenuItem
        ref={ref}
        className={cn(styles.miraDropdownMenuItem, className)}
        {...props}
      />
    );
  }
);

DropdownMenuItem.displayName = 'MiraDropdownMenuItem';

export const DropdownMenuCheckboxItem = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnDropdownMenuCheckboxItem
        ref={ref}
        className={cn(styles.miraDropdownMenuCheckboxItem, className)}
        {...props}
      />
    );
  }
);

DropdownMenuCheckboxItem.displayName = 'MiraDropdownMenuCheckboxItem';

export const DropdownMenuRadioItem = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnDropdownMenuRadioItem
        ref={ref}
        className={cn(styles.miraDropdownMenuRadioItem, className)}
        {...props}
      />
    );
  }
);

DropdownMenuRadioItem.displayName = 'MiraDropdownMenuRadioItem';

export const DropdownMenuLabel = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnDropdownMenuLabel
        ref={ref}
        className={cn(styles.miraDropdownMenuLabel, className)}
        {...props}
      />
    );
  }
);

DropdownMenuLabel.displayName = 'MiraDropdownMenuLabel';

export const DropdownMenuSeparator = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnDropdownMenuSeparator
        ref={ref}
        className={cn(styles.miraDropdownMenuSeparator, className)}
        {...props}
      />
    );
  }
);

DropdownMenuSeparator.displayName = 'MiraDropdownMenuSeparator';

// Re-export utility components
export {
  DropdownMenuTrigger,
  DropdownMenuShortcut,
  DropdownMenuGroup,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuRadioGroup,
};
